module.exports = {
      id: "074fba3f0459323ad72bd358541ff6fetoiletEquipment-wall-mounted-toilet.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#074fba3f0459323ad72bd358541ff6fetoiletEquipment-wall-mounted-toilet.svg",
      toString: function () {
        return this.url;
      }
    }